"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SERVICE_LIST_RESPONSE = exports.GET_PROPERTIES_LIST_RESPONSE = void 0;
exports.GET_PROPERTIES_LIST_RESPONSE = {
    total: 1,
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '9999',
                featureName: 'Shiny Feature',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '9857',
                featureName: 'Pets Allowed',
                featureCode: null,
                count: 1,
            },
            {
                featureId: '6428',
                featureName: 'Highchair Available',
                featureCode: null,
                count: 21,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 2,
                count: 1,
            },
        ],
        regions: {
            rhs1: [
                {
                    count: 1,
                    region: 'England',
                    id: 21667,
                },
            ],
            rhs2: [
                {
                    count: 1,
                    region: 'North West England',
                    id: 21952,
                },
            ],
            rhs3: [
                {
                    count: 1,
                    region: 'Cheshire',
                    id: 21953,
                },
            ],
            rhs4: [
                {
                    count: 1,
                    region: 'Cheshire',
                    id: 21954,
                },
            ],
            rhs5: [
                {
                    count: 1,
                    region: 'Chester',
                    id: 21955,
                },
            ],
        },
        grades: [
            {
                grade: '4',
                count: 1,
            },
        ],
        reviews: [],
    },
    properties: [
        {
            code: 'LP16571',
            displayName: 'Foxtail',
            features: [],
            property: {
                adults: 2,
                bathrooms: 3,
                bedrooms: 2,
                children: 1,
                infants: 0,
                pets: 1,
                sleeps: 3,
            },
            grade: '4',
            isCustomerChoice: false,
            petsGoFree: false,
            offers: ['Default Offer'],
            lengthOfStay: 7,
            location: 'Chester',
            images: [
                {
                    assetId: '10852518',
                    caption: 'Exterior | Wheelwright&rsquo;s Cottage, Rumburgh',
                },
            ],
            priceFrom: 100,
            price: 100,
            averageReviewScore: 3.4,
            rhs3: 'Cheshire::21953',
            USPs: [
                { id: '6948', value: 'Wifi' },
                { id: '10408', value: 'Car parking on site' },
                { id: '6401', value: 'Garden / Patio' },
            ],
            cardinality: 'SINGLE',
        },
    ],
    rhsLevel: 'rhs1',
};
exports.GET_SERVICE_LIST_RESPONSE = {
    total: 1,
    aggregations: {
        accommodationTypes: [],
        features: [
            {
                featureId: '6428',
                featureName: 'Highchair Available',
                featureCode: null,
                count: 21,
            },
            {
                featureId: '8821',
                featureName: 'Cot Available',
                featureCode: null,
                count: 21,
            },
            {
                featureId: '3084',
                featureName: 'Hot Tub - Private',
                featureCode: null,
                count: 6,
            },
            {
                featureId: '9857',
                featureName: 'Pets Allowed',
                featureCode: null,
                count: 12,
            },
        ],
        siteFeatures: [],
        bathrooms: [
            {
                bathrooms: 1,
                count: 17,
            },
            {
                bathrooms: 2,
                count: 4,
            },
            {
                bathrooms: 3,
                count: 1,
            },
        ],
        bedrooms: [
            {
                bedrooms: 3,
                count: 13,
            },
            {
                bedrooms: 2,
                count: 8,
            },
            {
                bedrooms: 4,
                count: 1,
            },
        ],
        regions: {
            rhs1: [],
            rhs2: [],
            rhs3: [],
            rhs4: [],
            rhs5: [],
        },
        grades: [],
        reviews: [],
    },
    properties: [
        {
            code: 'LP16571',
            displayName: 'Foxtail',
            features: [],
            grade: undefined,
            property: {
                adults: 4,
                bathrooms: 1,
                bedrooms: 2,
                children: 0,
                infants: 0,
                pets: 2,
                sleeps: 4,
            },
            images: [
                {
                    assetId: '10852518',
                    caption: 'Exterior | Wheelwright&rsquo;s Cottage, Rumburgh',
                },
            ],
            offers: undefined,
            priceFrom: 169,
            price: 169,
            isCustomerChoice: false,
            lengthOfStay: 7,
            petsGoFree: false,
            averageReviewScore: 4.1,
            USPs: [
                {
                    id: '6948',
                    value: 'Wifi',
                },
                {
                    id: '10408',
                    value: 'Car parking on site',
                },
                {
                    id: '6401',
                    value: 'Garden / Patio',
                },
            ],
            cardinality: 'SINGLE',
        },
    ],
    rhsLevel: 'rhs1',
};
//# sourceMappingURL=getPropertiesListResponse.js.map